import {ReactNode} from "react";

interface TipProps {
    title: string | ReactNode,
    description: string | ReactNode,
}

function Tip({title, description}: TipProps) {
    return (
        <>
            <b>
                {title}
                :
            </b>
            &nbsp;
            {description}
        </>
    )
}

export default Tip